<template>
  <div class="row">
    <div class="col-md-12">
      <div class="box box-primary">
        <div class="overlay" v-if="loadingStatsComites">
          <i class="fa fa-refresh fa-spin"></i>
        </div>
        <div class="box-header with-border">
          <h3 class="box-title">Statistiques générales pour les comités</h3>
          <!--<button class="btn btn-default btn-xs pull-right"-->
          <!--@click.prevent="getStatsComites(true)">-->
          <!--<i class="fa fa-refresh "></i>-->
          <!--</button>-->
        </div>
        <div class="box-body">

          <div class="col-md-3"
               v-for="province in getProvinces">
            <h4>Statistiques {{ province.province }}</h4>
            <ul v-for="annee in getAnnees().reverse()">
              <li><a href="#" @click.prevent="getStatsPDF(province,annee)">Statistiques ADEPS PDF {{ annee }}</a></li>
              <li><a href="#" @click.prevent="getStatsPDFArena(province,annee)">Statistiques ARENA PDF {{ annee }}</a></li>
              <li><a href="#" @click.prevent="getStatsExcel(province,annee)">Statistiques ADEPS Excel {{ annee }}</a></li>
              <li><a href="#" @click.prevent="getListingClubPDF(province,annee)">Listing clubs {{ annee }} ({{ getNombreClub(province.id, annee) }} clubs)</a></li>
              <li><a href="#" @click.prevent="getDiffAnnees(province,annee)">Diff. entre {{ annee - 1 }} et {{ annee }}</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import {mapGetters, mapActions} from 'vuex'

var _ = require('underscore')
var moment = require('moment')
var FileSaver = require('file-saver');
export default {
  data() {
    return {
      statsComites: null,
      loadingStatsComites: false,
      provinces: []
    }
  },
  props: {},
  computed: {
    ...mapGetters({
      getRoute: 'getRoute',
      getProvinces: 'getProvinces',
    }),

  },
  mounted: function () {
    this.loadProvinces()
    this.getStatsClub()
  },
  methods: {
    ...mapActions({
      setRecap: 'setRecap',
      setProvinces: 'setProvinces',
    }),
    orderedByYear: function (obj) {
      return _.sortBy(obj, 'annee').reverse()
    },
    getNombreClub: function (province, annee) {
      var anneeFound = _.find(this.statsClubs, function (item) {
        return item.annee == annee;
      })
      return anneeFound && anneeFound.nombre[province] ? anneeFound.nombre[province] : 0
    },
    getAnnees: function () {
      let retour = [];
      for (let i = 2007; i <= moment().year(); i++) {
        retour.push(i)
      }
      return retour;
    },
    getStatsPDF: function (province, annee) {
      if (!province || !annee)
        return;
      let self = this;
      this.loadingStatsComites = true
      this.$http.post
      (
        self.getRoute('Statistiques.StatsGeneralesForProvinces'),
        JSON.stringify({
          annee: annee,
          id_prov: province.id
        }),
        {responseType: 'blob'}
      ).then((response) => {
        this.loadingStatsComites = false
        var blob = new Blob([response.body], {type: "application/pdf;charset=utf-8"});
        FileSaver.saveAs(blob, province.province + "_" + annee + "_statistiquesADEPS.pdf");
        return response.blob();
      }, (response) => {
        self.$noty.error("Erreur dans la génération du fichier PDF")
        this.loadingStatsComites = false
      });
    },
     getStatsPDFArena: function (province, annee) {
      if (!province || !annee)
        return;
      let self = this;
      this.loadingStatsComites = true
      this.$http.post
      (
        self.getRoute('Statistiques.StatsGeneralesArenaForProvinces'),
        JSON.stringify({
          annee: annee,
          id_prov: province.id
        }),
        {responseType: 'blob'}
      ).then((response) => {
        this.loadingStatsComites = false
        var blob = new Blob([response.body], {type: "application/pdf;charset=utf-8"});
        FileSaver.saveAs(blob, province.province + "_" + annee + "_statistiquesARENA.pdf");
        return response.blob();
      }, (response) => {
        self.$noty.error("Erreur dans la génération du fichier PDF")
        this.loadingStatsComites = false
      });
    },
    getStatsExcel: function (province, annee) {
      if (!province || !annee)
        return;
      let self = this;
      this.loadingStatsComites = true
      this.$http.post
      (
        self.getRoute('Statistiques.StatsGeneralesForProvincesADEPSExcel'),
        JSON.stringify({
          annee: annee,
          id_prov: province.id
        }),
        // {responseType: 'blob'}
      ).then((response) => {
        // this.loadingStatsComites = false
        // var blob = new Blob([response.body], {type: "application/pdf;charset=utf-8"});
        // FileSaver.saveAs(blob, "ListingExcelAdeps_" + annee + "_" + province.id + ".xls");
        // return response.blob();
      }, (response) => {
        // self.$noty.error("Erreur dans la génération du fichier XLS")
        // this.loadingStatsComites = false
      });
      setTimeout(() => {
        self.$noty.success("Le fichier demandé vous sera envoyé par mail dés qu'il sera généré.")
        this.loadingStatsComites = false
      },2000)
    },
    getListingClubPDF: function (province, annee) {
      if (!province || !annee)
        return;
      let self = this;
      this.loadingStatsComites = true
      this.$http.post
      (
        self.getRoute('Statistiques.exportStatsAdepsListingClubForProvinces'),
        JSON.stringify({
          annee: annee,
          id_prov: province.id
        }),
        {responseType: 'blob'}
      ).then((response) => {
        this.loadingStatsComites = false
        var blob = new Blob([response.body], {type: "application/pdf;charset=utf-8"});
        FileSaver.saveAs(blob, province.province + "_" + annee + "_listing_clubs_ADEPS.pdf");
        return response.blob();
      }, (response) => {
        self.$noty.error("Erreur dans la génération du fichier PDF")
        this.loadingStatsComites = false
      });
    },
    getDiffAnnees: function (province, annee) {
      if (!province || !annee)
        return;
      let self = this;
      this.loadingStatsComites = true
      this.$http.post
      (
        self.getRoute('Statistiques.exportStatsDifferencesForProvinces'),
        JSON.stringify({
          annee: annee,
          id_prov: province.id
        }),
        {responseType: 'blob'}
      ).then((response) => {
        this.loadingStatsComites = false
        var blob = new Blob([response.body], {type: "application/pdf;charset=utf-8"});
        FileSaver.saveAs(blob, province.province + "_" + annee + "_comparaison.pdf");
        return response.blob();
      }, (response) => {
        self.$noty.error("Erreur dans la génération du fichier PDF")
        this.loadingStatsComites = false
      });
    },
    getStatsClub: function (force = false) {
      let self = this;
      this.loadingStatsClubs = true
      self.$http.post(this.getRoute('Statistiques.statistiquesGeneralesClubs'), {forceCache: force}).then((response) => {
        this.statsClubs = response.body
        this.loadingStatsClubs = false

      }, (response) => {
      });
    },
    loadProvinces: function () {
      this.$http.get(this.getRoute('getAllProvinces')).then((response) => {
        this.setProvinces(response.body)
      }, (response) => {
      });
    },
  },
  beforeRouteUpdate(to, from, next) {
  },

  beforeRouteEnter(to, from, next) {
  },
  watch: {},
  components: {}
}
</script>



// WEBPACK FOOTER //
// src/components/Secretariat/Statistiques/General/General_comites.vue